import PropTypes from 'prop-types';
import React from 'react';

import { IRON } from '@wetransfer/transfer/constant/colors';

const Lines = ({ className }) => (
  <svg viewBox="852 1501 230 30" className={className}>
    <rect
      fill={IRON}
      fillRule="evenodd"
      opacity=".5"
      x="852"
      y="1501"
      width="220"
      height="4"
      rx="2"
    />
    <rect
      fill={IRON}
      fillRule="evenodd"
      opacity=".5"
      x="852"
      y="1513"
      width="230"
      height="4"
      rx="2"
    />
    <rect
      fill={IRON}
      fillRule="evenodd"
      opacity=".5"
      x="852"
      y="1525"
      width="212"
      height="4"
      rx="2"
    />
  </svg>
);

Lines.propTypes = {
  className: PropTypes.string,
};

export default Lines;
